export default "skymp5-front/1a5c3b5b1fb5d26ea2a840baa579abd1.png";